import {
  CREATE_TRIP_ACTIVITY,
  SET_TRIP_ACTIVITIES,
  GET_TRIP_ACTIVITIES,
  UPDATE_TRIP_ACTIVITY,
} from './actionTypes'

export function createTripActivitySaga(data) {
  return {
    type: CREATE_TRIP_ACTIVITY,
    data,
  }
}

export function setTripActivities(data) {
  return {
    type: SET_TRIP_ACTIVITIES,
    data,
  }
}

export const updateTripActivitySaga = (data) => ({
  type: UPDATE_TRIP_ACTIVITY,
  data,
})

export function getTripActivitiesSaga(data) {
  return {
    type: GET_TRIP_ACTIVITIES,
    data,
  }
}
